export const EXCMCASE_CREATE_RESET = 'EXCMCASE_CREATE_RESET'
export const EXCMCASE_CREATE_SET_CREATED = 'EXCMCASE_CREATE_SET_CREATED'
export const EXCMCASE_CREATE_SET_ERROR = 'EXCMCASE_CREATE_SET_ERROR'
export const EXCMCASE_CREATE_SET_VIOLATIONS = 'EXCMCASE_CREATE_SET_VIOLATIONS'
export const EXCMCASE_CREATE_TOGGLE_LOADING = 'EXCMCASE_CREATE_TOGGLE_LOADING'
